import React, { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEmailsData,
  toggleEmailPin,
} from "../../store/features/emailsSlice";
import EmailList from "../../components/Email/EmailList";
import EmailBody from "../../components/Email/EmailBody";
import { sortEmails } from "../../utils/emailUtils";


const EmailsView = ({ threadId }) => {
  const dispatch = useDispatch();
  const { shipments, status: shipmentStatus } = useSelector((state) => state.shipments);
  const { emails:emailsData, status:emailStatus, error,mailOpen, currentMail,pinnedEmails } = useSelector((state) => state.emails);
  const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
  const { thread_id, case_number, documents, emailBodies} = shipment;
  const [tab, setTab] = useState("Inbox");
  const [sortOption, setSortOption] = useState("new-to-old");
  const targetEmail = "supplychain@linear-works.com"
  // Get emails for the current thread
  const emails = emailsData[case_number] || [];
  console.log("emails",emails)
  // Fetch emails when component mounts or threadId changes
  useEffect(() => {
    if (case_number) {
      dispatch(fetchEmailsData({caseNumber:case_number,email:targetEmail,thread_id}));
    }
  }, [dispatch, case_number]);

  // Handle loading state
  if (emailStatus === "loading") {
    return <p>Loading emails...</p>;
  }

  // Handle empty state
  if (!emails.length) {
    return <p>No emails available for this thread.</p>;
  }

  // Handle toggling pinned emails
  const onTogglePin = (emailId, isPinned) => {
    dispatch(toggleEmailPin(threadId, emailId, isPinned));
  };

  // Filter emails based on tab selection
  const filteredEmails = emails.filter((email) => {
    if (tab === "Inbox") return email.status === "received";
    if (tab === "Sent") return email.status === "sent";
    if (tab === "Draft") return email.status === "draft";
    return true;
  });

  // Sort emails
  const sortedEmails = [...filteredEmails].sort((a, b) => {
    if (sortOption === "new-to-old") {
      return new Date(b.date_received) - new Date(a.date_received);
    }
    if (sortOption === "old-to-new") {
      return new Date(a.date_received) - new Date(b.date_received);
    }
    if (sortOption === "sender") {
      return a.sender.localeCompare(b.sender);
    }
    return 0;
  });
  console.log("sorted_email",sortedEmails)
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6">
      {/* Email List */}
      <div className="w-full col-span-1 md:col-span-1">
        <div className="flex justify-between items-center gap-4 mb-4">
          {/* Tab Options */}
          <div className="flex gap-1">
            {["Inbox", "Sent", "Draft"].map((item) => (
              <div
                key={item}
                className={`cursor-pointer px-3 py-2 rounded-md hover:text-font hover:rounded-full hover:bg-bg-Gray ${
                  tab === item
                    ?"font-bold text-logo underline underline-offset-4"
                    : "text-gray-700"
                }`}
                onClick={() => setTab(item)}
              >
                {item}
              </div>
            ))}
          </div>

          {/* Sorting Dropdown */}
          <div className="relative">
            <select
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
              className="py-2 rounded-md focus:outline-none"
            >
              <option className="hover:bg-logo" value="new-to-old">Sort by Date</option>
              <option className="hover:bg-logo" value="sender">Sort by Name</option>
            </select>
          </div>
        </div>
        <EmailList
          emails={sortedEmails}
          pinnedEmailIds={pinnedEmails}
          onTogglePin={onTogglePin}
          currentEmailId={currentMail?.id}
          threadId={threadId}
        />
      </div>

      {/* Email Body */}
      <div className="pl-2 w-full col-span-1 md:col-span-2">
        {mailOpen ? (
          <EmailBody threadId={threadId} caseNumber={case_number} email={currentMail} />
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-gray-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-20 h-20 mb-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
              />
            </svg>
            <p>Select an email to view its content</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailsView;
